import React, { useState } from 'react'
import { api } from '../../utils/api'
import { postageTaskLabel } from '../../../../shared/collection-postage-tasks.js'

const COPIED_MS = 1500

/**
 * One hand job on a cancelled collection: what to do, the tracking numbers to
 * copy, and a Done button that tells Prism it is done. Used in the cancel
 * answer and on the "Postage to cancel" list, so both work the same way.
 */
export default function PostageTaskItem({ task, onDone }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [copied, setCopied] = useState(false)
  const done = !!task.done_at

  async function markDone() {
    setBusy(true)
    setError(null)
    try {
      const updated = await api.post(`/api/deals/collections/postage-tasks/${task.collection_postage_task_id}/done`, {})
      onDone?.(updated)
    } catch (e) {
      setError(`Could not mark this done: ${e.message}`)
    } finally {
      setBusy(false)
    }
  }

  async function copyTrackingNumbers() {
    await navigator.clipboard.writeText(task.tracking_numbers)
    setCopied(true)
    setTimeout(() => setCopied(false), COPIED_MS)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 13, padding: '4px 0' }}>
      <span style={{ flex: '1 1 200px', textDecoration: done ? 'line-through' : 'none' }}>{postageTaskLabel(task.kind)}</span>
      {task.tracking_numbers && (
        <>
          <span style={{ fontFamily: 'monospace' }}>{task.tracking_numbers}</span>
          <button type="button" className="btn btn-xs" onClick={copyTrackingNumbers}>{copied ? 'Copied' : 'Copy'}</button>
        </>
      )}
      {done
        ? <span className="badge badge-success">Done{task.done_by ? ` by ${task.done_by}` : ''}</span>
        : <button type="button" className="btn btn-secondary btn-xs" style={{ padding: '4px 10px' }} disabled={busy} onClick={markDone}>
            {busy ? 'Saving' : 'Done'}
          </button>}
      {error && <span role="alert" style={{ flexBasis: '100%', fontSize: 12, color: 'var(--color-error)' }}>{error}</span>}
    </div>
  )
}
